import { useForm } from "react-hook-form";
import type { CheckoutProps } from "../CheckoutProps";
import { getCurrentUserName } from "../helpers/users";
import { useCheckoutPaywallPrice } from "./useCheckoutPaywallPrice";

// TODO: Use `CheckoutFormValuesProps` type for `useForm` once we have completed the checkout refactor
// TODO: pre-populate `community_member_billing_info_attributes` with `props.memberBillingInfo` if present
export const useCheckoutFormMethods = (props: CheckoutProps) => {
  const { currentCommunity, currentUser, isMemberAddressRequired } = props;
  const paywallPrice = useCheckoutPaywallPrice(props);

  return useForm({
    defaultValues: {
      community_id: currentCommunity.id,
      paywall_price_id: paywallPrice.id,
      user_id: currentUser?.id,
      email: currentUser?.email,
      name: getCurrentUserName(currentUser),
      payment_method_type: "card",
      coupon_code_applied: false,
      community_member_billing_info_attributes: {},
      community_member_billing_info_address_attributes_complete:
        !isMemberAddressRequired,
    },
  });
};
